/**
 * Passive HUD — zone location label and evidence toasts. Owned by UI.
 */
import type { EventBus } from '../core/types'
import {
  TOAST_DURATION_MS,
  TOAST_PREFIX,
  ZONE_LABEL_INDOOR,
  ZONE_LABEL_OUTDOOR
} from './constants'
import { el } from './dom'

const ZONE_SHOW_CLASS = 'gum-zone-show'

export const createHud = (root: HTMLElement, bus: EventBus): void => {
  const zoneLabel = el('div', 'gum-zone-label')
  const toastStack = el('div', 'gum-toasts')
  root.append(zoneLabel, toastStack)

  bus.on('zone:changed', ({ zone }) => {
    zoneLabel.textContent = zone === 'indoor' ? ZONE_LABEL_INDOOR : ZONE_LABEL_OUTDOOR
    zoneLabel.classList.remove(ZONE_SHOW_CLASS)
    // Force a reflow so the fade animation restarts on repeat crossings.
    void zoneLabel.offsetWidth
    zoneLabel.classList.add(ZONE_SHOW_CLASS)
  })

  bus.on('clue:collected', ({ clue }) => {
    const toast = el('div', 'gum-toast', `${TOAST_PREFIX}${clue.name.toUpperCase()}`)
    toastStack.append(toast)
    window.setTimeout(() => toast.remove(), TOAST_DURATION_MS)
  })
}
